import { h, Component } from "preact";
import { css } from "emotion";
import RichTextDisplay from "../../components/RichTextDisplay";
import facebookIcon from "../../assets/icons/ic_facebook.svg";
import instagramIcon from "../../assets/icons/ic_instagram.svg";
import linkedInIcon from "../../assets/icons/ic_linkedin.svg";
import twitterIcon from "../../assets/icons/ic_twitter.svg";

const styles = {
  wrapper: css`
    width: 100%;
    max-width: 1000px;
    margin-top: 32px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 4px;
    box-shadow: 0 1px 10px 2px rgba(32, 7, 64, 0.13);
    background: #ffffff;
    @media (max-width: 600px) {
      max-width: auto;
      width: auto;
      margin-left: 14px;
      margin-right: 14px;
      margin-top: 24px;
    }
  `,
  title: css`
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #323232;
  `,
  container: css`
    width: 100%;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
  `,
  topRow: css`
    padding: 32px 0px 20px;
    @media (max-width: 600px) {
      padding: 20px 12px 16px 12px;
    }
  `,
  socialMedia: css`
    text-align: center;
    height: 54px;
    padding: 15px;
    border-top: solid 1px #dedede;
    // border-bottom: solid 1px #dedede;
  `,
  icon: css`
    margin-right: 12px;
    width: 24px;
    height: 24px;
  `,
  slide: css`
    height: 340px;
  `
};

/**
 * Tour about page
 *
 * @param {*} props
 * @returns
 */
const About = props => {
  const {
    name,
    description,
    facebook,
    linkedIn,
    twitter,
    instagram,
    eventCardBackgroundColor
  } = props;

  const showSocialMedia = facebook || linkedIn || twitter || instagram;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.topRow}>
          <div className={styles.title}>{name}</div>
          <RichTextDisplay html={description} />
        </div>
        {showSocialMedia ? (
          <div className={styles.socialMedia}>
            {facebook && facebook !== "" && (
              <a href={facebook} target="_blank">
                <img
                  src={facebookIcon}
                  id="facebook"
                  alt="facebook"
                  className={styles.icon}
                />
              </a>
            )}
            {instagram && instagram !== "" && (
              <a href={instagram} target="_blank">
                <img
                  src={instagramIcon}
                  alt="instagram"
                  className={styles.icon}
                />
              </a>
            )}
            {linkedIn && linkedIn !== "" && (
              <a href={linkedIn} target="_blank">
                <img
                  src={linkedInIcon}
                  alt="linkedIn"
                  className={styles.icon}
                />
              </a>
            )}
            {twitter && twitter !== "" && (
              <a href={twitter} target="_blank">
                <img src={twitterIcon} alt="twitter" className={styles.icon} />
              </a>
            )}
          </div>
        ) : null}
        {/* <div className={styles.slide} /> */}
      </div>
    </div>
  );
};

export default About;



// WEBPACK FOOTER //
// ./routes/tours/About.js